import { Table } from '@radix-ui/themes'
import { useCallback } from 'react'

export const LoadingRows = () => {
  const loadingRows = useCallback(() => {
    return new Array(10).fill(null).map((_, i) => {
      return (
        <Table.Row key={i}>
          <Table.RowHeaderCell>{i}</Table.RowHeaderCell>
          <Table.Cell>{i}</Table.Cell>
          <Table.Cell>{i}</Table.Cell>
          <Table.Cell>{i}</Table.Cell>
        </Table.Row>
      )
    })
  }, [])

  return loadingRows()
}
